import { useLinkOnSameOrg } from '@monorepo/shared/hooks/navigation/useLinkOnSame/useLinkOnSameOrg';

export function useOrgSpecificNewFormLink() {
  return useLinkOnSameOrg('/data-setup/forms/new');
}
